
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 560 175","fill":"#231F20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M142.378 153.073L90.855 13.366c-6.04-16.35-30.273-12.045-30.273 5.4v76.839l-30.31-82.239C24.232-2.984 0 1.36 0 18.804V158.51c0 8.609 6.983 15.632 15.627 15.632h112.106c10.87-.037 18.382-10.874 14.645-21.069zM425.7 153.073L374.176 13.366c-6.039-16.35-30.272-12.045-30.272 5.4v76.839l-30.31-82.239c-6.04-16.35-30.272-12.045-30.272 5.4v139.707c0 8.609 6.983 15.632 15.626 15.632h112.106c10.871 0 18.42-10.837 14.646-21.032zM233.27 96.511V77.556c0-10.799-8.757-19.559-19.552-19.559h-1.359c-10.795 0-19.552-8.76-19.552-19.559V19.56C192.807 8.76 184.05 0 173.254 0h-1.359c-10.795 0-19.552 8.76-19.552 19.559v135.025c0 10.799 8.757 19.559 19.552 19.559h82.287c10.795 0 19.552-8.76 19.552-19.559v-18.955c0-10.799-8.757-19.559-19.552-19.559h-1.359c-10.795 0-19.553-8.76-19.553-19.559zM466.956 173.728c-17.854 0-32.311-14.462-32.311-32.322V25.412c0-13.064 10.607-23.675 23.667-23.675h78.021c13.06 0 23.667 10.61 23.667 23.675v55.24c0 51.39-41.672 93.076-93.044 93.076z"}})])
          )
        }
      }
    